import React from "react";
import { NavLink  } from "react-router-dom";

import HeroSection from "../sections/HeroSection/HeroSection";
import OneLineSection from "../sections/OneLineSection/OneLineSection";
import AdvencedSection from "../sections/AdvencedSection/AdvencedSection";
import GallerySection from "../sections/GallerySection/GallerySection";
import DescriptionSection from "../sections/DescriptionSection/DescriptionSection";
import AddressAllegroSection from "../sections/AddressAllegroSection/AddressAllegroSection";

const Realizacje = () => (
  <React.Fragment>
    <HeroSection image="./assets/realizacje_banner.jpg" />
    <OneLineSection
      title="nasze realizacje"
      theme="black"
      content={
        <p>
          Jeśli jeszcze nie czujesz się do końca przekonany, zapraszamy do galerii naszych realizacji – to tylko mała cząsteczka we wszechświecie naszych kreacji.
        </p>
      }
    />
    <AdvencedSection
      title="zobacz nasze realizacje"
      theme="blue"
      items={[
        {title: 'poligrafia', image: './assets/mozemy_pomoc-poligrafia.png', link: '/poligrafia#poligrafia'},
        {title: 'druk etykiet', image: './assets/mozemy_pomoc-druk_etykiet.png', link: '/poligrafia#etykiety'},
        {title: 'projektowanie', image: './assets/mozemy_pomoc-projektowanie.png', link: '/studio'}
    ]}
    />
    <GallerySection
      photos={[
        {
          image: './assets/products/efiore/thumb.jpg',
          link: '/realizacje/efiore'
        },
        {
          image: './assets/products/glikol/thumb.jpg',
          link: '/realizacje/glikol'
        },
        {
          image: './assets/products/miodowy_ogrod/thumb.jpg',
          link: '/realizacje/miodowy_ogrod'
        },
        {
          image: './assets/products/bassau/thumb.jpg',
          link: '/realizacje/bassau'
        },
        {
          image: './assets/products/nails/thumb.jpg',
          link: '/realizacje/nails'
        },
        {
          image: './assets/products/nirobio/thumb.jpg',
          link: '/realizacje/nirobio'
        },
      ]}
    />
    <DescriptionSection
      imageButton="./assets/etykiety-link.png"
      imageLink="/poligrafia#wydruk-etykiet"
    >
      <NavLink to="/#contact-form">
        <img className="image-button" alt="" src="./assets/calculate-link.png"/>
      </NavLink>
    </DescriptionSection>
    <AddressAllegroSection />
  </React.Fragment>
);

export default Realizacje;
